export default __webpack_public_path__ + "static/media/logoBiale.4461bd66.png";